"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "merano": {
    "c4180d19": [{
      "hkey": "e6dbb08f",
      "slug": "merano",
      "name": "Merano",
      "primary": true,
      "skipSearch": false
    }],
    "maia": [{
      "hkey": "e6dbb08f",
      "slug": "merano",
      "name": "Merano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "90659ca8": [{
      "hkey": "e6dbb08f",
      "slug": "merano",
      "name": "Merano",
      "primary": true,
      "skipSearch": false
    }],
    "quarazze": [{
      "hkey": "e6dbb08f",
      "slug": "merano",
      "name": "Merano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "951f78f2": [{
      "hkey": "e6dbb08f",
      "slug": "merano",
      "name": "Merano",
      "primary": true,
      "skipSearch": false
    }],
    "sinigo": [{
      "hkey": "e6dbb08f",
      "slug": "merano",
      "name": "Merano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;